import { render, staticRenderFns } from "./CollectDataList.vue?vue&type=template&id=145f7464&scoped=true&"
import script from "./CollectDataList.vue?vue&type=script&lang=js&"
export * from "./CollectDataList.vue?vue&type=script&lang=js&"
import style0 from "./CollectDataList.vue?vue&type=style&index=0&id=145f7464&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f7464",
  null
  
)

export default component.exports